import { render, staticRenderFns } from "./WhatsAppMultiProduct.vue?vue&type=template&id=aa7d27ce&scoped=true&"
import script from "./WhatsAppMultiProduct.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMultiProduct.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMultiProduct.vue?vue&type=style&index=0&id=aa7d27ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7d27ce",
  null
  
)

export default component.exports